import { render, staticRenderFns } from "./detalle-oferta.vue?vue&type=template&id=12849e06&"
import script from "./detalle-oferta.vue?vue&type=script&lang=js&"
export * from "./detalle-oferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports